import React from "react";

const SelfieMissingBanner = ({ user, navigate }) => {
  if (user?.selfie) return null;

  return (
    <div
      className="selfie-missing-banner"
      style={{
        background: "#fffbe6",
        border: "1px solid #ffe58f",
        padding: "12px 18px",
        borderRadius: "12px",
        marginBottom: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
      }}
    >
      <div>
        <strong style={{ color: "#d48806", fontSize: "14px" }}>
          📸 Upload a Selfie to unlock "My Photos" AI filter!
        </strong>
        <p style={{ margin: "2px 0 0", fontSize: "13px", color: "#595959" }}>
          Upload a selfie in Profile Settings so AI can automatically find your
          photos in this group.
        </p>
      </div>
      <button
        className="quickphoto-pill-back"
        style={{
          background: "#faad14",
          color: "#ffffff",
          border: "none",
          padding: "8px 16px",
          borderRadius: "16px",
          fontSize: "13px",
          fontWeight: 600,
          cursor: "pointer",
        }}
        onClick={() => navigate("/profile-setting")}
      >
        Upload Selfie
      </button>
    </div>
  );
};

export default SelfieMissingBanner;
